/* eslint no-undef: 0 */

export default {
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    item: {},
  }),
  methods: {
    agruparCamposPorTabela(campos) {
      const data = {
        perfis: {},
        enderecos: {},
        telefones: {},
        outros: {}
      };

      (campos || []).forEach(campo => {
        const tabelaColuna = campo["tabela=coluna"];
        const valor = campo.valor || null;

        if (typeof tabelaColuna === "string" && tabelaColuna.includes("=")) {
          const [tabela, coluna] = tabelaColuna.split('=');

          if (tabela && coluna) {
            if (!data[tabela]) data[tabela] = {};
            data[tabela][coluna] = valor;
          } else {
            // Se não conseguir separar corretamente, cai como "outro"
            data.outros[campo.identificacao || "outros"] = valor;
          }
        } else {
          data.outros[campo.identificacao || "outros"] = valor;
        }
      });

      return data;
    },
    createDataLead(campos) {
      const data = this.agruparCamposPorTabela(campos);

      if (!data.leads) {
        data.leads = {};
      }
      data.leads.criado_por_usuario_id = (((this.$store || {}).getters || {}).contexto || {}).id || null;

      if ((data.perfis || {}).cpf_cnpj)
        data.perfis.cpf_cnpj = this.$functions.onlyNumber(data.perfis.cpf_cnpj);

      if ((data.perfis || {}).rg)
        data.perfis.rg = this.$functions.onlyNumber(data.perfis.rg);

      if ((data.perfis || {}).nascimento)
        data.perfis.nascimento = this.$functions.formatDateToRequest(data.perfis.nascimento);

      if (data.leads.validade_carteira)
        data.leads.validade_carteira = this.$functions.formatDateToRequest(data.leads.validade_carteira);

      if ((data.enderecos || {}).cep)
        data.enderecos.cep = this.$functions.onlyNumber(data.enderecos.cep);

      if ((data.telefones || {}).telefone)
        data.telefones.telefone = this.$functions.onlyNumber(data.telefones.telefone);

      return data;
    },

    createDataProfissional(eh_reserva = false, campos) {
      const data = this.agruparCamposPorTabela(campos);

      if (!data.profissionais) {
        data.profissionais = {};
      }

      data.profissionais.status_cadastro = eh_reserva;

      if ((data.perfis || {}).cpf_cnpj)
        data.perfis.cpf_cnpj = this.$functions.onlyNumber(data.perfis.cpf_cnpj);

      if ((data.perfis || {}).rg)
        data.perfis.rg = this.$functions.onlyNumber(data.perfis.rg);

      if ((data.profissionais || {}).numero_pis)
        data.profissionais.numero_pis = this.$functions.onlyNumber(data.profissionais.numero_pis);

      if ((data.enderecos || {}).cep)
        data.enderecos.cep = this.$functions.onlyNumber(data.enderecos.cep);

      if ((data.telefones || {}).telefone)
        data.telefones.telefone = this.$functions.onlyNumber(data.telefones.telefone);

      if ((data.perfis || {}).nascimento)
        data.perfis.nascimento = this.$functions.formatDateToRequest(data.perfis.nascimento);

      if ((data.profissionais || {}).data_inclusao)
        data.profissionais.data_inclusao = this.$functions.formatDateToRequest(data.profissionais.data_inclusao);

      return data;
    }
  }
};
